import { render, staticRenderFns } from "./ArchiveRecordingDialog.vue?vue&type=template&id=60ddcf54&scoped=true"
import script from "./ArchiveRecordingDialog.vue?vue&type=script&lang=js"
export * from "./ArchiveRecordingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddcf54",
  null
  
)

export default component.exports